import { render, staticRenderFns } from "./SamSearch.vue?vue&type=template&id=ce297e34&scoped=true&shadow"
import script from "./SamSearch.vue?vue&type=script&lang=js&shadow"
export * from "./SamSearch.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamSearch.vue?vue&type=style&index=0&id=ce297e34&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ce297e34",
  null
  ,true
)

export default component.exports